import { schema } from "./attribute-schema";

const Ajv = require("ajv");
const ajv = new Ajv({});
const ajvValidate = ajv.compile(schema);

export function validate(values: { [key: string]: any }): string[] {
  const isValid = ajvValidate(values);
  const errors = (ajvValidate.errors || []).map(({ message }: any) => message);
  if (!isValid && errors.length === 0) {
    errors.push("is invalid");
  }
  return errors;
}
